import * as React from 'react';

interface IFormProps{
    children: React.ReactNode;
    id?: string;
    style?: React.CSSProperties;
    className?: string;
}

export const Form = (props: IFormProps) => {
    
    return (
        <form
            id={props.id}
            style={props.style}
            className={props.className}
        >
            {props.children}
        </form>
    );
};
